import { URLS } from 'constants/urls';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
const FORCE_RESET_KEY = 'force-reset-v1'; // ← incrementa quando precisar forçar reset geral

const VersionChecker = () => {
  useEffect(() => {
    const clearAllCookies = () => {
      document.cookie.split(';').forEach(cookie => {
        const name = cookie.split('=')[0].trim();
        if (!name) return;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${URLS.cookieDomain}`;
      });
    };

    const clearAndRedirect = currentVersion => {
      localStorage.clear();
      clearAllCookies();

      // restaura as chaves de controle após limpar
      if (currentVersion) localStorage.setItem('app-version', currentVersion);
      localStorage.setItem(FORCE_RESET_KEY, 'true');

      window.location.replace('/logout?reason=version_update');
    };

    const checkVersion = () => {
      const meta = document.querySelector('meta[name="app-version"]');
      const currentVersion = meta?.getAttribute('content');
      const lastKnownVersion = localStorage.getItem('app-version');
      const hasReset = localStorage.getItem(FORCE_RESET_KEY);
      // sem versão no meta, não tem como comparar
      if (!currentVersion) return;

      //  sem versão anterior conhecida: só grava, não reseta
      // (primeira visita ou storage foi limpo — não é mismatch real)
      if (!lastKnownVersion) {
        localStorage.setItem('app-version', currentVersion);
        if (!hasReset) localStorage.setItem(FORCE_RESET_KEY, 'true');
        return;
      }
      // já está na versão correta e já fez o reset → não faz nada
      if (lastKnownVersion === currentVersion && hasReset) return;

      const versionMismatch = currentVersion && lastKnownVersion && currentVersion !== lastKnownVersion;

      if (!hasReset || versionMismatch) {
        Sentry.logger.info('[VersionChecker] disparou reset', {
          hasReset,
          versionMismatch,
          currentVersion,
          lastKnownVersion,
        });
        clearAndRedirect(currentVersion);
        return;
      }

      // sem mismatch, só atualiza a versão
      if (currentVersion) localStorage.setItem('app-version', currentVersion);
    };

    checkVersion();

    const interval = setInterval(checkVersion, 300000); // 5 minutos

    return () => clearInterval(interval);
  }, []);

  return null;
};

export default VersionChecker;
